// extracted by mini-css-extract-plugin
export var fadeIn = "_id-1";
export var modalContent = "_id-3";
export var overlay = "_id-0";
export var popoverContent = "_id-2";
export var results = "_id-5";
export var searchInputWrapper = "_id-4";